import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import InvoicesList from '../../pages/invoices/InvoicesList';
import { InvoiceViewModel } from '../../models/Invoice/InvoiceViewModel';

interface EstimateInvoicesProps {
  estimateId: number;
}

export default function EstimateInvoices({
  estimateId,
}: EstimateInvoicesProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [invoices, setInvoices] = useState([] as InvoiceViewModel[]);

  const {
    user: { organization },
  } = useAuth();

  async function getInvoices() {
    if (organization) {
      setIsLoading(true);
      const { data } = await api.get(
        `organizations/${organization.id}/estimates/${estimateId}/invoices`
      );
      setInvoices(data.data);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getInvoices();
  }, [organization, estimateId]);

  return (
    <div className='table-responsive'>
      <InvoicesList invoices={invoices} openInvoiceInNewTab />
    </div>
  );
}
